import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {UsersSearch} from '../../../models/users-search.interface';
import {WeeeSystems} from '../../../models/weee_systems.interface';
import {Role} from '../../../models/role.interface';

@Component({
  selector: 'app-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrls: ['./users-filter.component.scss']
})
export class UsersFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    name: [''],
    firstName: [''],
    weeeSystem: [],
    role: [],
    status: [2]
  });

  get nameControl(): FormControl {
    return this.searchForm.get('name') as FormControl;
  }
  get firstNameControl(): FormControl {
    return this.searchForm.get('firstName') as FormControl;
  }
  get weeeSystemControl(): FormControl {
    return this.searchForm.get('weeeSystem') as FormControl;
  }
  get roleControl(): FormControl {
    return this.searchForm.get('role') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Input()
  roles!: Role[];
  @Input()
  weeeSystems!: WeeeSystems[];

  @Output()
  search: EventEmitter<UsersSearch> = new EventEmitter<UsersSearch>();


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: UsersSearch = {
      name: this.nameControl.value,
      firstName: this.firstNameControl.value,
      weeeSystem: this.weeeSystemControl.value,
      role: this.roleControl.value,
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

}
